/* eslint-disable max-len */
import React from 'react';
import {
  Box, Typography, Accordion, AccordionSummary, AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FAQ = () => (
  <Box
    id="faqs"
    sx={{
      width: '90%', margin: '70px auto', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
    }}
  >
    <Box>
      <Typography sx={{
        background: 'linear-gradient(to right, #F49867, #AE67FA)', textFillColor: 'transparent', backgroundClip: 'text', fontSize: '50px', fontWeight: '600', lineHeight: '40px', padding: '20px 0',
      }}
      >
        FAQs
      </Typography>
    </Box>
    <Box>
      <Accordion sx={{ background: 'linear-gradient(to bottom right, #1B78DE, #0F4279)', color: '#fff' }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography sx={{ fontWeight: '300' }}>How Is It Different From other Courses</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{ fontWeight: '300' }}>
            Accessin Code&apos;s private 1-on-1 online lessons are the fastest way to learn how to code. Working 1-on-1 over Zoom with your own private instructor, Accessin Code&apos;s students work their way through our structured curriculum and complete weekly homework assignments, receive weekly progress reports, and more.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion sx={{ background: 'linear-gradient(to bottom right, #1B78DE, #0F4279)', color: '#fff' }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography sx={{ fontWeight: '300' }}>Is This Self-Paced Or Live</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{ fontWeight: '300' }}>
            We do both - our self-paced online courses are great for self-starters and feature over 700 hours of student projects. We also provides awesome support from a team of engineers and teachers to help you solve problems through chat or screen share if you ever get stuck or have questions.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion sx={{ background: 'linear-gradient(to bottom right, #1B78DE, #0F4279)', color: '#fff' }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography sx={{ fontWeight: '300' }}>My child doesn&apos;t have any experience. Are these courses good for beginners?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{ fontWeight: '300' }}>
            Absolutely! Our introductory and beginner courses (labeled as ‘BEGINNER’ on the platform) are designed for students with little to no experience. These courses start off slower and ramp up steadily. Videos can be rewound and re-watched if necessary, and the video speed can be slowed down or sped up to best accommodate different speeds. Our online instructional team is available for additional help when needed.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  </Box>
);

export default FAQ;
